import React, { useState, useEffect } from 'react';

const AnimatedLogo = ({ className = "" }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
      "/images/sidhisochlogo.png",
      "/images/sanjaypardeshilogo.png"
  ];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? 1 : 0
      );
    }, 3000); // Change image every 3 seconds
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className={`relative flex items-center justify-center ${className}`} style={{ width: '128px', height: '56px' }}>
      {images.map((src, index) => (
        <img
          key={index}
          src={src}
          alt="सीधी सोच सीधी बात - लोगो"
          className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-opacity duration-1000 ease-in-out ${
            index === currentImageIndex 
              ? 'opacity-100' 
              : 'opacity-0'
          }`}
          style={{
            width: '122px',
            height: '56px',
            objectFit: 'contain',
            transitionProperty: 'opacity',
            transitionDuration: '1000ms',
            transitionTimingFunction: 'ease-in-out',
            transform: src.includes('sanjaypardeshilogo.png')
              ? 'translate(-50%, -50%) scale(1.35)'
              : 'translate(-50%, -50%)'
          }}
        />
      ))}
    </div>
  );
};

export default AnimatedLogo;